<template>
<el-row>
   <headertop></headertop>
   <div class="all" ref="father_file">
     <span @click="back()" style="cursor:pointer;color: blue;">返回</span>
    <div class="con">
      <div class="video_div" >
        <div class="video_right">
          <video ref="videoPlayer" class="video-js video vjs-big-play-centered" width="100%" :height="height" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
          </video>
        </div>
      </div>
    </div>
   </div>
   <footerbom></footerbom>
</el-row>
</template>
<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import pdf from 'vue-pdf'
  export default {
    name: 'App',
    data() {
      return {
        play:{
          info:{},
          status:false,
        },
        trigger:false,
        player: null,
        videoOptions: {
          // lang: 'zh-CN',
          autoplay: false,//自动播放
          controls: true,//用户可以与之交互的控件
          // loop:false,//视频一结束就重新开始
          muted:false,//默认情况下将使所有音频静音
          // aspectRatio:"16:9",//显示比率
          // preload:false,//预加载
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          playbackRates: [0.5, 1, 1.5,2,3],//倍数
          errorDisplay: false,
          fluid: true,
          fullscreen:{
              options: {navigationUI: 'hide'}
          },
          sources:[{
            src: "",
            type: ""
          }],
        },
        file:{
          num:this.$route.query.num,
          info:{},
        },
        height:'',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      pdf
    },
    mounted:function(){
     this.get_info()
     this.change_height()
    },
    methods: {
      back(){
        window.close()
      },
      support(opration){
        let _this=this
        _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'file',type:'1',num:_this.file.num,opration:opration}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              if(opration=='support'){
                _this.file.info.support=res.data.data
              }else{
                _this.file.info.collect=res.data.data
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      change_height(){
        let _this=this
        let fatherH = _this.$refs.father_file.offsetHeight
        _this.height=fatherH  + 'px'
      },

      get_info() {
        let _this=this
        _this.axios.get('/v2/user_resource/get_file_info',{params:{file:_this.file.num, type:'study'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.file.info=res.data.data
              if(res.data.data.video){
                _this.videoOptions.sources[0].type=res.data.data.video.type
                _this.videoOptions.sources[0].src=res.data.data.video.src
                if(_this.player){
                  _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
                  _this.player.load()
                }else{
                  _this.$nextTick(()=>{
                    _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

                    })
                  })
                }
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handle(row) { },
    //滚动到顶部
    top(){
      if (this.trigger) return;
        var curTop = document.documentElement.scrollTop || document.body.scrollTop
        var each = curTop / 2000
        var timer = setInterval(function () {
            this.trigger = true
            curTop -= each
            each += 5
            if (curTop <= 0) {
                clearInterval(timer)
                trigger = false
            }
            window.scrollTo(0, curTop)
        }, 10)
    },
    //添加笔记
    onSubmit(){},
    //超链接点击跳转
    chaolianjie(url){
      window.open(url,"_blank");
    }


  }}
</script>

<style scoped>
.all{
  min-height: calc(100vh - 330px);
  width: 62%;
  padding: 20px;
  margin: 0 15%;
  z-index: 100;
  background-color: white;
  overflow: hidden;
}
.video_div{
  width: 100%;
  height: 100%;
  margin: 1% 0px;
  overflow: hidden;
}
.video_left{
  background-color: #000000;
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  float: left;
}
.video_right{
  background-color: #000066;
  width: 100%;
  height: 100%;
}
.con{
  margin-top: 1.5rem;
}
.player-div{
   width: 100%;
    height: 40px;
    margin-top: 1.5rem;
   /* background-color: rgb(80, 79, 77); */
}
  .player-div button{
      height: 100%;
      background-color: rgb(80, 79, 77);
      border: none;
      margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/File/file_video.vue